import { CHANNELS, PRODUCTS } from '../lib/constants/appConstants';

export const CAMPAIGN_CONFIGS = [
  {
    product: PRODUCTS.CAR,
    channel: CHANNELS.GJENSIDIGE,
    campaigns: []
  },
  {
    product: PRODUCTS.HOME,
    channel: CHANNELS.RIKSHEM,
    campaigns: [
      {
        campaignDiscountPercentage: 8,
        campaignName: 'Rabatt Rikshem',
        campaignDescription: 'Rabatt Rikshem är giltig första året och motsvarar 1 kostnadsfri månad.'
      }
    ]
  }
];
